import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAr: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAr"><Path fillRule="evenodd" clipRule="evenodd" d="M1 5V20H8.18693L12 16.5822L15.8131 20H23V5H1ZM7.5 9.375C6.3264 9.375 5.375 10.3264 5.375 11.5C5.375 12.6736 6.3264 13.625 7.5 13.625C8.6736 13.625 9.625 12.6736 9.625 11.5C9.625 10.3264 8.6736 9.375 7.5 9.375ZM14.375 11.5C14.375 10.3264 15.3264 9.375 16.5 9.375C17.6736 9.375 18.625 10.3264 18.625 11.5C18.625 12.6736 17.6736 13.625 16.5 13.625C15.3264 13.625 14.375 12.6736 14.375 11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAr;
